import { cn } from '@/lib/utils'

type Props = {
  severity?: string
}

const severityConfig: Record<string, string> = {
  trace: 'bg-slate-500',
  debug: 'bg-violet-500',
  info: 'bg-sky-500',
  warn: 'bg-amber-500',
  error: 'bg-destructive',
  fatal: 'bg-fuchsia-500',
}

export const SeverityIndicator = ({ severity }: Props) => {
  const normalized = severity?.toLowerCase()
  const colorClass = normalized ? severityConfig[normalized] : undefined

  if (!colorClass) {
    return <span className="w-1 h-5 shrink-0" />
  }

  return (
    <span
      className={cn('w-1 h-5 shrink-0 rounded-full', colorClass)}
      title={normalized}
    />
  )
}
